<template>
  <el-form ref="baseForm" :rules="rules" :model="fromData">
  <search-box @subSearch="subSearch" :fromData="fromData">
    <el-form-item class="item" label="物料编码：" prop="materialCode">
      <el-input  v-model="fromData.searchCriteria.materialCode" :placeholder="$store.state.remark.matterCode"></el-input>
    </el-form-item>

    <el-form-item class="item" label="选择工厂：">
      <el-select v-model="fromData.searchCriteria.factoryId" @change="getFactory" filterable :placeholder="$store.state.remark.factorySelect">
      	<el-option
      	v-for="item in factoryList"
        :label="item.value"
      	:value="item.factoryId">
      	</el-option>
      </el-select>
    </el-form-item>

    <el-form-item class="item" label="库存地点：" prop="inventoryCode">
      <el-select v-model="fromData.searchCriteria.inventoryId" @change="changeFstock" :disabled="isFactoryInventory" :placeholder="$store.state.remark.fstock">
          <el-option
           v-for="item in fstockList"
           :key="item.inventoryId"
           :label="item.value"
           :value="item.inventoryId">
          </el-option>
        </el-select>
    </el-form-item>

    <el-form-item class="item time-between" label="选择日期：" prop="searchTime">
      <el-date-picker
        v-model="searchTime"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions">
      </el-date-picker>
    </el-form-item>
  </search-box>
  </el-form>
</template>

<script>
import {factoryApi,fstockApi} from 'api/base.js';
import searchBox from 'components/common/search.vue';
import { mapState, mapActions } from 'vuex';
export default{
  components:{
    searchBox
  },
	props:{
    fromData:Object
	},
	data(){
		return {
      rules: {
        materialCode:[{message: '',trigger: 'change'}]
      },
      fstockList:[],//库存地信息
      isFactoryInventory:true,//库存地是否禁用
      //获取库位信息
      fromFstock:{
      	"page": 1,
      	"pageSize": 10000,
      	"searchCriteria": {
      		"factoryCode":0
      	}
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        },
        {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        },
        {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      searchTime:''
		}
	},
	created(){
    //获取工厂
    this.getFactoryList();
    //设置默认日期最近一个月
    const startTime = new Date().getTime() - 3600 * 1000 * 24 * 30;
    const endTime = new Date();
    this.searchTime= [startTime,endTime];
	},
	computed:{
	  ...mapState("cache",['factoryList'])
	},
	methods:{
	  ...mapActions('cache',['setFactoryList']),
	    async getFactoryList(){
	     if(!this.factoryList){
	       //工厂列表
	       let factoryList = await this.$post(factoryApi.list,this.$store.state.getAllPage);
	       if(factoryList.status){
	         let listArr = factoryList.data.list;
	         listArr.map((item)=>{
	           return item.value = item.factoryCode+' ' + item.factoryDesc;
	         });
	         this.setFactoryList(listArr);
	       }else{
	         this.setFactoryList(null);
	       }
	     }
	   },
    getFactory(val){
      let obj = this.factoryList.find(v=>v.factoryId === val);
      if(obj){
        this.fromData.searchCriteria.factoryCode = obj.factoryCode;
        this.fromData.searchCriteria.factoryDesc = obj.factoryDesc;
        this.fromData.searchCriteria.factoryId = obj.factoryId;
        this.$set(this.fromData.searchCriteria,'inventoryId','');
        this.getFstock(val);
      }
    },
    //提交搜索
    subSearch(){
      //console.log(JSON.stringify(this.fromData));
      let timeArr = this.searchTime;
      //console.log(timeArr);
      let stime = this.$moment(timeArr[0]).format("YYYY-MM-DD");
      let etime = this.$moment(timeArr[1]).format("YYYY-MM-DD");
      this.fromData.searchCriteria.startDate = stime;
      this.fromData.searchCriteria.endDate = etime;
      this.$emit('subSearch');
    },
    //清空搜索
    subClear(){
      this.fromData.searchCriteria = {};
    },
    //获取库位信息
    async getFstock(fid){
    	this.fromFstock.searchCriteria.factoryId = fid;
    	let fstockList = await this.$post(fstockApi.list,this.fromFstock);
    	if(fstockList.status){
    	  this.fstockList = fstockList.data.list;
    	  this.fstockList.map((item)=>{
    	    return item.value = item.inventoryCode+' ' + item.inventoryDesc;
    	  });
    	  this.isFactoryInventory = false;
    	}else{
    	  this.fstockList = null;
    	  this.isFactoryInventory = true;
    	}
    },
    //库位信息改变
    changeFstock(item){
    	let res = this.fstockList.find(v=>v.inventoryCode===item);
    	if(res){
    		this.fromData.searchCriteria.inventoryCode = res.inventoryCode;
    	}
    }
	}
}
</script>

<style>
</style>
